export default "__VITE_ASSET__yAYwMJzY__"